import { Text } from '@driftt/dds'
import React from 'react'

import { StyledList } from './ValidationDrawer.styles'

export const configByType = {
  guardrailReplyGuidelines: {
    validationTitle: '',
    title: 'Reply guidelines',
    buttonText: 'Use guidelines as written',
    placeholder: 'Type reply guidelines here',
    info: (
      <>
        <Text>Write your reply guidelines using the tips below</Text>
        <Text>
          <StyledList>
            <li>
              <strong>Use plain English</strong>
            </li>
            <li>
              <strong>
                Provide instructions, rather than specific phrases. 
              </strong>{' '}
              Example: Do not answer the question directly. Instead, let them
              know that Drift takes security very seriously.
            </li>
            <li>
              <strong>
                When entering URLs, also provide a name for that page. 
              </strong>{' '}
              Example: Direct chat visitor to Pricing page:
              http://drift.com/pricing.
            </li>
            <li>
              <strong>Use quotation marks for exact phrasing.</strong> Example:
              Reply to them with “Thank you for your interest.”
            </li>
          </StyledList>
        </Text>
      </>
    ),
  },
  description: {
    validationTitle: 'Description',
    title: 'Description',
    buttonText: 'Use this description',
    placeholder: 'Type scenario description...',
    info: (
      <>
        <Text>Write your scenario description using the tips below.</Text>
        <Text>
          <StyledList>
            <li>
              <strong>Use plain English</strong>
            </li>
            <li>
              <strong>Describe the site visitor's goal.</strong> For example:
              "When someone is seeking pricing information", or "When visitor is
              inquiring about the affiliate program".
            </li>
            <li>
              <strong>Provide identifying phrases.</strong> These are examples
              of what a chat visitor might say to trigger this scenario. For
              example: "How much does it cost?" or "Do you have a partner
              program?"
            </li>
          </StyledList>
        </Text>
      </>
    ),
  },
  instructions: {
    validationTitle: 'Reply guidelines',
    title: 'Reply guidelines',
    buttonText: 'Use these reply guidelines',
    placeholder: 'Type reply guidelines...',
    info: (
      <>
        <Text>Write your reply guidelines using the tips below.</Text>
        <Text>
          <StyledList>
            <li>
              <strong>Use plain English</strong>
            </li>
            <li>
              <strong>
                Provide instructions, rather than specific phrases.
              </strong>{' '}
              For example: "Do not answer the question directly. Instead, let
              them know that Drift takes security very seriously."
            </li>
            <li>
              <strong>
                When entering URLs, also provide a name for that page.
              </strong>{' '}
              For example: "Direct chat visitor to Pricing page:
              http://drift.com/pricing."
            </li>
          </StyledList>
        </Text>
      </>
    ),
  },
  exit: {
    validationTitle: 'Exit confirmation question',
    title: 'Exit confirmation question',
    buttonText: 'Use this exit confirmation question',
    placeholder: 'Type exit confirmation question...',
    info: (
      <>
        <Text>
          An offramp is a way to exit out of the AI responses node and connect
          back into the main playbook. Before exiting the node, we'll first
          confirm with the site visitor using your exit confirmation question.
        </Text>
        <Text>Write your exit confirmation question using the tips below.</Text>
        <Text>
          <StyledList>
            <li>
              <strong>Use plain English</strong>
            </li>
            <li>
              <strong>
                Write your questions so that visitors answer with a simple "Yes"
                or "No."
              </strong>
            </li>
            <li>
              <strong>
                "Yes" answers should correspond with exiting the AI responses
                node.
              </strong>{' '}
              "No" answers will keep site visitors in the node and allow them to
              continue asking questions.
            </li>
          </StyledList>
        </Text>
      </>
    ),
  },
}
